import { html, View } from 'rune-ts';
import klass from './Lists.module.scss';
import { staticTypoPcMo, typo, typoPcMo } from '../../../../shared/typography/typo';
import { PopupStoreItemCard } from '../../../components/cells/PopupStore/PopupStoreItemCard';
import { PopupStoreItemCardType } from '../../../../features/PopupStores/type';

export interface EmptyListProps {
  last_popups: PopupStoreItemCardType[];
  is_mobile: boolean;
  type: string;
}

export class EmptyList extends View<EmptyListProps> {
  override template() {
    const { last_popups, is_mobile, type } = this.data;

    const empty_title = {
      upcoming: ET('mps2::popup_store::empty::upcoming_title'),
      now: ET('mps2::popup_store::empty::now_title'),
      archived: ET('mps2::popup_store::empty::archived_title'),
    }[type];

    const empty_desc = ET('mps2::popup_store::empty::desc');

    return html`
      <div class="${klass.empty_list_container}">
        <div class="${klass.empty_visual}">
          <img
            class="${klass.empty_img}"
            src="//s3.marpple.co/files/u_1504988/2024/6/original/49fc020f01773202427eb699f16f7ac039673e101.png"
          />
          <div>
            <h3 class="${klass.empty_title} ${typo('20_bold')}">${empty_title}</h3>
            <p class="${klass.empty_desc} ${typo('16_medium')}">
              ${is_mobile ? html.preventEscape(empty_desc.replace('\n', '<br/>')) : empty_desc}
            </p>
          </div>
        </div>
        <div class="${klass.recent_closed_list}">
          <div class="${klass.list_header}">
            <h4 class="${typoPcMo({ is_mobile, pc: '16_bold', mo: '12_medium' })}">
              ${ET('mps2::popup_store::empty::last_popups')}
            </h4>
            <a
              href="${`/${ET.lang}/@/popup-store?tab=archived`}"
              class="${staticTypoPcMo({ is_mobile, pc: 'unica_16_medium', mo: 'unica_12_medium' })}"
            >
              ${ET('mps2::popup_store::empty::see_more')}
            </a>
          </div>
          <div class="${klass.list}">
            ${last_popups?.map(
              (popup) =>
                new PopupStoreItemCard({
                  item: popup,
                  is_mobile,
                  use_in: 'popup_store',
                }),
            )}
          </div>
        </div>
      </div>
    `;
  }
}
